import { render, staticRenderFns } from "./TagManager.vue?vue&type=template&id=1e81ab23&"
import script from "./TagManager.vue?vue&type=script&lang=js&"
export * from "./TagManager.vue?vue&type=script&lang=js&"
import style0 from "./TagManager.vue?vue&type=style&index=0&id=1e81ab23&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports